import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import PageLayout from './components/PageLayout';
import HomePage from './pages/HomePage';
import PlanosPage from './pages/PlanosPage';
import ProductPlaceholderPage from './pages/ProductPlaceholderPage';
import './styles.css';

const App = () => (
  <LanguageProvider>
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <PageLayout metaPath="/">
              <HomePage />
            </PageLayout>
          }
        />
        <Route
          path="/planos"
          element={
            <PageLayout metaPath="/planos">
              <PlanosPage />
            </PageLayout>
          }
        />
        <Route
          path="/converlead"
          element={
            <PageLayout>
              <ProductPlaceholderPage product="converlead" />
            </PageLayout>
          }
        />
        <Route
          path="/axys"
          element={
            <PageLayout>
              <ProductPlaceholderPage product="axys" />
            </PageLayout>
          }
        />
      </Routes>
    </BrowserRouter>
  </LanguageProvider>
);

export default App;
